//helper function to return the value or, or a default value of an objects property if the property is missing
const objectHasProperty = (object, property, value) => {
  return object.hasOwnProperty(property) ? object[property] : value;
};

export { objectHasProperty };
